import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import styles from './DragAndDropList.styles';
import ListItem from './ListItem';

const useStyles = makeStyles(styles);

const DragAndDropList = ({ items, onDragEnd, idField, component }) => {
  const classes = useStyles();

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId="droppable">
        {provided => (
          <div ref={provided.innerRef} {...provided.droppableProps}>
            {items.map((item, index) => (
              <ListItem item={item} index={index} onDragEnd={onDragEnd} idField={idField} component={component} />
            ))}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
};
DragAndDropList.defaultProps = {};
DragAndDropList.propTypes = {
  items: PropTypes.array,
  onDragEnd: PropTypes.func,
  idField: PropTypes.string,
  component: PropTypes.any,
};

export default DragAndDropList;
